/*================================================================================== */
/* Jquery START ==================================================================== */
jQuery(document).ready(function ($) {

    // Fallback for object-fit on older browsers ------------------------------
    $(function () {
        objectFitImages()
    });

    //Verify if popin of age confirmation is activated or not
    if ($("#popinConfirmAge").css("display") == "none") {

        if (window.matchMedia("(max-width: 767px)").matches) {
            AOS.init({
                once: true,
                duration: 500,
                offset: 150,
                easing: 'cubic-bezier(0.105, 0.615, 0.010, 0.755)',
                anchorPlacement: 'top-center',
                mobile: true,
            });
        } else {
            AOS.init({
                once: true,
                duration: 500,
                offset: 300,
                easing: 'cubic-bezier(0.105, 0.615, 0.010, 0.755)',
                anchorPlacement: 'top-center',
                mobile: true,
            });
        }
    }

    $(document).on("click tap", ".confirm-age__cta", function() {
        if (window.matchMedia("(max-width: 767px)").matches) {
            AOS.init({
                once: true,
                duration: 500,
                offset: 150,
                easing: 'cubic-bezier(0.105, 0.615, 0.010, 0.755)',
                anchorPlacement: 'top-center',
                mobile: true,
            });
        } else {
            AOS.init({
                once: true,
                duration: 500,
                offset: 300,
                easing: 'cubic-bezier(0.105, 0.615, 0.010, 0.755)',
                anchorPlacement: 'top-center',
                mobile: true,
            });
        }
    });

    // Success form coupe des crus

    $('#crusModal').modal('show');


    // Check mobile device
    function isMobileDevice() {
        return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
    };

    // HEADER ----------------------------------------------------------------------

    //$('#header').addClass('header--fixed');

    // Header fixed top
    $(window).bind('scroll', function () {
        if ($(window).scrollTop() > 130) {
            $('#header').addClass('header--fixed');
           // $('#headerMenuLogo').addClass('header-menu__logo--small');
            // $('#headerMenuList').addClass('header-menu__list--small-black');
           // $('#headerMenuSearch').addClass('header-menu__search--aligned d-flex align-items-lg-center');
           // $('#headerMenuLanguage').addClass('header-menu__language--aligned d-flex align-items-center');
        } else {
            $('#header').removeClass('header--fixed');
            //$('#headerMenuLogo').removeClass('header-menu__logo--small');
            // $('#headerMenuList').removeClass('header-menu__list--small-black');
           //$('#headerMenuSearch').removeClass('header-menu__search--aligned');
           // $('#headerMenuLanguage').removeClass('header-menu__language--aligned d-flex align-items-lg-center');
        }

    });

    // Trigger richmenu
    $(document).on('click tap', '.header-richmenu-trigger', function () {
        var target = $(this).attr('data-target');
        if (!isMobileDevice()) {
            if ($(target).css('display') == 'none') {
                $('.header-richmenu').slideUp(0);
                $(target).slideDown(0);
            } else if ($(target).css('display') == 'block') {
                $('.header-richmenu').slideUp(0);
            }
        } else {
            if ($(target).css('display') == 'none') {
                $('.header-richmenu').css('display', 'none');
                $(target).css('display', 'block');
            } else if ($(target).css('display') == 'block') {
                $('.header-richmenu').css('display', 'none');
            }
        }
    });

    // Trigger richmenu
    $('.header-richmenu-trigger').mouseover(function () {

        if (!isMobileDevice()) {

            var target = $(this).attr('data-target');
            if ($(target).css('display') == 'none') {
                $('.header-richmenu').slideUp(0);
                $(target).slideDown(0);
                $('#header').addClass('header--active');
                $('#headerMenuList').addClass('header-menu__list--black');
            }
        }
    });

    $('.header-richmenu-trigger').click(function (e) {

        if (isMobileDevice()) {
            e.preventDefault();
        }
    });

    $('.header-richmenu-trigger').parent().mouseleave(function (e) {
        if (!isMobileDevice()) {

            var target = $(this).children('a').attr('data-target');
            var next_element = e.toElement || e.relatedTarget;

            if (target === '#' + $(next_element).attr('data-over')) {

            } else {

                if ($(next_element).attr('class') === "header-link") {

                } else {

                    if ($(next_element).attr('data-any') === "any") {

                    } else {
                        $('.header-richmenu').slideUp(0);
                        $('#header').removeClass('header--active');
                        $('#headerMenuList').removeClass('header-menu__list--black');
                    }

                }
            }
        }
    });

    $('.header-richmenu').mouseleave(function (e) {
        var target = '#' + $(this).attr('id');

        var next_element = e.toElement || e.relatedTarget;

        if (target === $(next_element).attr('data-over') || $(next_element).attr('data-any') === "any") {

        } else {
            $('.header-richmenu').slideUp(0);
            $('#header').removeClass('header--active');
            $('#headerMenuList').removeClass('header-menu__list--black');
        }

    });


    // Close richmenu when clicked outside of the header
    /*$(document).mouseup(function (e) {
        var container = $('header').unbind('click');
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            $('.header-richmenu').hide();
            $('#header').removeClass('header--active');
            $('#headerMenuList').removeClass('header-menu__list--black');
        }
    });*/

    $(document).on( 'click touchstart',function (e) {
        var container = $('header').unbind('click');
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            $('.header-richmenu').hide();
            $('#header').removeClass('header--active');
            $('#headerMenuList').removeClass('header-menu__list--black');
        }
    });

    // Burger icon on mobile & tablet
    $('.header-menu__burger').click(function () {
        $('.header-menu__burger').toggleClass('header-menu__burger--open');
        $('.header-menu__logo').toggleClass('header-menu__logo--hidden');
        $('.header-menu__list').toggleClass('header-menu__list--active-sm');
        $('body').toggleClass('mobile-menu-visible');
        $('.header-richmenu').css('display', 'none');
    });

    $('.fa-arrow-left').click(function () {
        $('.header-richmenu').css('display', 'none');
    });

    // Language selector
    $('.arrow-lang-collapse').click(function () {
        $('.other-lang').slideToggle(300);

        if ($(this).hasClass('fa-arrow-down')) {
            $(this).removeClass('fa-arrow-down');
            $(this).addClass('fa-arrow-up');
            return;
        }

        if ($(this).hasClass('fa-arrow-up')) {
            $(this).removeClass('fa-arrow-up');
            $(this).addClass('fa-arrow-down');
            return;
        }
    });


    // SEARCH MODAL  ---------------------------------------------------------------

    $(document).on("click tap", ".header-menu__search", function() {
        $(".search-modal").show();
        $(".search-modal__modal-bg").show();
        $(".search-modal").addClass("show-modal");
    });
    $(document).on("click tap", ".search-modal__close, .search-modal__modal-bg", function() {
        $(".search-modal").removeClass("show-modal");
        $(".search-modal__modal-bg").hide();
        $(".search-modal").hide();
    });

    // Add styles on active search-filter
    $('.search-filter__tab').on("click", function () {
        if (typeof $(this).attr('for') !== typeof undefined && $(this).attr('for') !== false) {
            var inputTarget = $('#' + $(this).attr('for'));
            if (inputTarget.prop('type') == 'radio') {
                $('input[name="' + inputTarget.prop('name') + '"] + label').removeClass('search-filter__tab--active');
            }
        }

        $(this).toggleClass('search-filter__tab--active');
    });

    // BLOCK SLIDER  ----------------------------------------------------------------

    // Hero slider initialization
    $('.single-item').slick({
        autoplay: true,
        autoplaySpeed: 3000,
        draggable: false,
        speed: 300,
        dots: true,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    draggable: true,
                }
            }
        ]
    });

    // Arrow scroll to next section
    $('.arrow-scroll').click(function (e) {
        var jump = $(this).closest('section').nextAll('section');
        var sectionPosition = $(jump).offset();
        $('html, body').stop().animate({scrollTop: sectionPosition.top - 88}, 500); //88 is header height
        e.preventDefault();
    });

    $('.scroll-to-section').on('click', function (e) {
        e.preventDefault();

        var section = $(this).data('section-target');

        if (section) {
            $('html, body').animate({
                scrollTop: $('#' + section).offset().top
            }, 500);
        }
    });

    // BLOCK PARTNERS -------------------------------------------------------------------

    function setPartnersHeight() {
        $('.partners__box-container').height($('.partners__box-container').width());
    }
    setPartnersHeight()

    // BLOCK DISCOVER  -------------------------------------------------------------------

    // Discover card height equal to dynamic width.
    $('.discover-card').height($('.discover-card').width());

    // Card-img card height equal to dynamic width.
    var card_min_height = $('.card-img-card').width() - ($('.card-img-card').width() / 5);

    $('.card-img-card').css('min-height', card_min_height);

    // Show more info

    $(document).on("click touch", ".discover__show-more-btn", function() {
        $(this).parents(".discover__show-more-btn-container").prev(".discover__more-info").toggle();
        $(this).find(".discover__show-more-btn__text-more").toggle();
        $(this).find(".discover__show-more-btn__text-less").toggle();
    });

    // BLOC CARD IMG ----------------------------------------------------------

    function cardImgResize() {
        var imgWidth = $('.card-img__img--landscape').width();
        $('.card-img__img--landscape').height(imgWidth * (786 / 1155)); // to keep the size ratio
    }

    cardImgResize();
    $(window).on('resize', function() {
        setPartnersHeight();
        cardImgResize();
    });

    /////////////////////////////////////
    /// START ADVANCED SEARCH
    /////////////////////////////////////

    $("#advanced-search-form").keydown(function (event) {
        if (event.keyCode == 13) {
            event.preventDefault();
            doneTyping();
        }
    });

    $("#advanced-search-page-form").keydown(function (event) {
        if (event.keyCode == 13) {
            event.preventDefault();
            doneTypingSearchPage();
        }
    });

    $('#search-icon').click(function () {
        doneTyping();
        doneTypingSearchPage();
    });

    function doneTypingSearchPage() {
        var xhr;
        $('.search-filter__loader').css('display', 'block');
        if (xhr) {
            xhr.abort();
        }
        var data = $('#search-page .search-field').parents('form').serialize();
        $('#advanced-search-page-result').css('opacity', 0);
        xhr = $.ajax({
            'url': ajaxurl,
            'type': 'GET',
            'data': data + '&action=get_advanced_search_page_action',
            success: function (response) {
                var res = JSON.parse(response);

                $('.search-filter__loader').css('display', 'none');

                $('#advanced-search-page-result').html(res).css('opacity', 1);

                AOS.refresh();
            }
        });
    }

    function doneTyping() {
        var xhr;
        $('.search-filter__loader').css('display', 'block');
        if (xhr) {
            xhr.abort();
        }
        var data = $('.search-field').parents('form').serialize();
        $('#advanced-search-result').css('opacity', 0);
        xhr = $.ajax({
            'url': ajaxurl,
            'type': 'GET',
            'data': data + '&action=get_advanced_search_action',
            success: function (response) {
                var res = JSON.parse(response);

                $('.search-filter__loader').css('display', 'none');

                $('#advanced-search-result').html(res).css('opacity', 1);

                $('#searchModal').animate({
                    scrollTop: $('.search-filter').offset().top - 200
                }, '750');

                AOS.refresh();
            }
        });
    }

    $('.search-field__input').on('focus', function (ev) {
        if ($('.search-field__input').val() !== '') {
        }
    });

    $(document).mouseup(function (e) {
        if (!$('.zone-form-search').is(e.target) && $('.zone-form-search').has(e.target).length === 0) {
            // $('.advanced-search').hide();
        }
    });

    var typingTimer; //timer identifier
    var doneTypingInterval = 500; //time in ms

    $('.loadfromajax').on('change keyup paste click', function (ev) {
        clearTimeout(typingTimer);
        if ($(this).val().length >= 2) {
            typingTimer = setTimeout(doneTyping, doneTypingInterval);
        }
        else {
            // $('.advanced-search').hide();
        }
    });

    $('#search-page .loadfromajax').on('change keyup paste click', function (ev) {
        clearTimeout(typingTimer);
        if ($(this).val().length >= 2) {
            typingTimer = setTimeout(doneTypingSearchPage, doneTypingInterval);
        }
        else {
            // $('.advanced-search').hide();
        }
    });

    // FILTER CASTLE ----------------------------------------------------------------------------

    // Check and uncheck advanced filter appellation when selecting an appellation filter ( because appellation filter is duplicated in the castle listing )
    $('.search-filter__checkbox').on("touchstart click", function() {
        var thisName = $(this).attr("name");

        var advancedFilter = $(".castle-listing__advanced-filters").find("input[name='" + thisName + "']");

        $(advancedFilter).prop("checked", !advancedFilter.prop("checked"));


    });



    $(".castle-listing__advanced-filters input[name^='castles[appellation]']").on("touchstart click", function() {
        var thisName = $(this).attr("name");

        var filter = $(".castle-listing__appellation-filters").find("input[name='" + thisName + "']");

        $(filter).prop("checked", !filter.prop("checked"));
        var filterName = $(filter).attr('id');
        $("label[for='"+ filterName +"']").removeClass("search-filter__tab--active");


    });

    $('.loadfromajaxcastle').on("change", function (e) {

        //if ($('.castle-listing__language-checkbox').val() === "fr_FR") {

            var data = $('#castle-form').serialize();
            $.ajax({
                'url': ajaxurl,
                'type': 'GET',
                'async': false,
                'data': data + '&action=get_castle_search_action',
                success: function (response) {
                    var res = JSON.parse(response);
                    $('#castle-listing-results').empty().append(res);

                    animateScrollToElement($('.castle-listing-results__results-title'));

                    AOS.refresh();
                }
            });
        //}

    });

    var typingTimer; //timer identifier
    var doneTypingInterval = 500; //time in ms

    $('.loadcastlefromajax').on('change keyup paste click', function (ev) {
        clearTimeout(typingTimer);
        if ($(this).val().length >= 1) {
            typingTimer = setTimeout(doneTypingCastle, doneTypingInterval);
        }
        else {
            // $('.advanced-search').hide();
        }
    });

    function doneTypingCastle() {
        var xhr;

        if (xhr) {
            xhr.abort();
        }

        var data = $('#castle-form').serialize();
        $.ajax({
            'url': ajaxurl,
            'type': 'GET',
            'async': false,
            'data': data + '&action=get_castle_search_action',
            success: function (response) {
                var res = JSON.parse(response);
                $('#castle-listing-results').empty().append(res);
                AOS.refresh();
            }
        });
    }

    //Listing castle autocomplete

        var data = $('#castle-form').serialize();

        $('.loadcastlefromajax').autoComplete({
            source: function(name, response) {
                $.ajax({
                    type: 'GET',
                    dataType: 'json',
                    url: ajaxurl,
                    data: data + '&action=get_listing_names_action&name='+ name,
                    success: function(data) {
                        response(data);
                    }
                });
            }
        });



    window.onload = function() {
        setTimeout (function () {
            if (typeof castleListingHasGet !== 'undefined' && castleListingHasGet === true) {
                if ($('.castle-listing-results__results-title')[0]) {
                    animateScrollToElement($('.castle-listing-results__results-title'));
                } else {
                    animateScrollToElement($('.castle-listing-results__error'));
                }
            }

            if (window.ambassadorFiltered === true) {
                animateScrollToElement($('#ambassador-result'));
            }
        }, 0);
    };
    function animateScrollToElement(element) {

            var currentPosition = $(window).scrollTop();
            var quarterWindowHeigh = $(window).height()/4;
            var resultsDivPosition = element.offset().top;
            resultsDivPosition -= currentPosition;
            resultsDivPosition -= quarterWindowHeigh;

            if (resultsDivPosition > 0) {

                $('html,body').animate({
                    scrollTop: '+=' + resultsDivPosition + 'px'
                }, 'fast');
            } else {
                resultsDivPosition = - resultsDivPosition;
                $('html,body').animate({
                    scrollTop: '-=' + resultsDivPosition + 'px'
                }, 'fast');
            }


    }
    // FILTER RECIPE ----------------------------------------------------------------------------

    $('.loadfromajaxrecipe').on('change', function (ev) {
        var data = $('#recipe').serialize();

        var is_listing = $(this).parents("form").attr("data-listing");

        if (is_listing == null){
            is_listing = 0;
        }

        $.ajax({
            'url': ajaxurl,
            'type': 'GET',
            'data': data + '&is_listing=' + is_listing + '&action=get_recipe_search_action',
            success: function (response) {
                var res = JSON.parse(response);
                $('#recipe-result').empty().append(res);
                AOS.refresh();
            }
        });
    });

    // FILTER ARTICLE ----------------------------------------------------------------------------
    
    $('.loadfromajaxposts').on('change', function (ev) {
        var data = $('.article').parents('form').serialize();

        var is_listing = $(this).parents("form").attr("data-listing");

        if (is_listing == null){
            is_listing = 0;
        }

        $.ajax({
            'url': ajaxurl,
            'type': 'GET',
            'data': data + '&is_listing=' + is_listing + '&action=get_article_search_action',
            success: function (response) {
                var res = JSON.parse(response);
                $('#article-result').empty().append(res);
                AOS.refresh();
            }
        });
    });


    var pparticle_filters = [];

    $('.loadfromajaxposts_new').on('change', function (ev) {
	const selectedValue = $(this).val();
	load_posts_new_filter(selectedValue);
    });

    function buildUrlParams(array) {
	return array.map(item => `post[${encodeURIComponent(item)}]=${encodeURIComponent(item)}`).join('&');
    }

    function load_posts_new_filter(selectedValue) {
	let data = '';
	let data2 = '';
	
	//@todo : A commenter pour plusieurs params
	pparticle_filters = [];

	
	
	pparticle_filters.push(selectedValue);

        var is_listing = $("#post_category").attr("data-listing");

        if (is_listing == null){
            is_listing = 0;
        }
	
	if(selectedValue == 'all'){
	    data = `filter_all=1`
	} else {
	    data = buildUrlParams(pparticle_filters);
	}

	if ($(".loadfromajaxposts_new__order").length) {
	    const selectValueOrder = $(".loadfromajaxposts_new__order").val();
	    data2 = `&posts_order[${selectValueOrder}]=${selectValueOrder}`
	}

        $.ajax({
            'url': ajaxurl,
            'type': 'GET',
            'data': data + data2 + '&is_listing=' + is_listing + '&action=get_article_search_action',
            success: function (response) {
                var res = JSON.parse(response);
                $('#article-result').empty().append(res);
                AOS.refresh();
            }
        });
	
	
/*	let data2 = ''
	
	if ($(".loadfromajaxambassador_new__order").length) {
	    const selectValueOrder = $(".loadfromajaxambassador_new__order").val();
	    data2 = `&ambassador_order[${selectValueOrder}]=${selectValueOrder}`
	}
	
	
        $.ajax({
            'url': ajaxurl,
            'type': 'GET',
            'data': data + '&is_listing=' + is_listing + '&action=get_article_search_action',
            success: function (response) {
                var res = JSON.parse(response);
                $('#article-result').empty().append(res);
                AOS.refresh();
            }
        });
	*/
	
    }

    $('.loadfromajaxposts_new').on('change', function (ev) {
        const selectedValue = $(this).val();
	load_posts_new_filter(selectedValue);
    });

    $('.loadfromajaxposts_new__order').on('change', function() {
        const selectedValue = $('.loadfromajaxposts_new').val();
	load_posts_new_filter(selectedValue)
    });
    
    
    
    
    

    // FILTER EVENT ----------------------------------------------------------------------------
    $('.loadfromajaxevent').on('change', function (ev) {

        //Remove last filter when new filter is checked ||START||
        var currentCheckboxChecked = false;
        if ($(this).prop('checked')) {
            currentCheckboxChecked = true;
        }

        var currentCheckboxSlug = $(this).attr("name");

        $('.loadfromajaxevent').each( function() {
            $(this).prop('checked',false);

            if (currentCheckboxSlug != $(this).attr("name")) {
                $('label[for="' + $(this).attr("id") + '"]').removeClass('search-filter__tab--active')
            }
        });

        if (currentCheckboxChecked) {
            $(this).prop('checked',true);
        }
        //Remove last filter when new filter is checked ||END||

        //Change load more btn text ||START||

        var btn_text = $(this).attr('data-btn-text');

        $('#load-more-events-btn').text(btn_text);

        //Change load more btn text ||END||

        var data = $('.event').parents('form').serialize();

        var is_listing = $(this).parents("form").attr("data-listing");

        if (is_listing == null){
            is_listing = 0;
        }

        $.ajax({
            'url': ajaxurl,
            'type': 'GET',
            'data': data + '&is_listing=' + is_listing + '&action=get_event_search_action',
            success: function (response) {
                var res = JSON.parse(response);
                $('#event-result').empty().append(res);
                AOS.refresh();
            }
        });
    });

    // Change ajax pagination href --------------

    $(document).on('click touch', '#ajax-search-pagination a', function(e) {
        e.preventDefault();

        var link = $(this).attr('href');

        var newLink = "";
        if (link.includes("page")) {
            newLink = link.substring(link.indexOf("page"));
        } else if (link.includes("?")) {
            newLink = link.substring(link.indexOf("?"));
        }

        var pageLink = $('#search-page').attr("data-current-link");

        var resultsLink = pageLink + newLink;

        window.location.href = resultsLink;

    });

    $(document).on('click touch', '#ajax-event-pagination a', function(e) {
        e.preventDefault();

        var link = $(this).attr('href');

        var newLink = "";
        if (link.includes("page")) {
            newLink = link.substring(link.indexOf("page"));
        } else if (link.includes("?")) {
            newLink = link.substring(link.indexOf("?"));
        }

        var pageLink = $('#event-result').attr("data-current-link");

        var resultsLink = pageLink + newLink;

        window.location.href = resultsLink;

    });

    
    
    // FILTER AMBASSADOR ----------------------------------------------------------------------------

    
    $('.loadfromajaxambassador').on('change', function (ev) {

        //Remove last filter when new filter is checked ||START||
        var currentCheckboxChecked = false;
        if ($(this).prop('checked')) {
            currentCheckboxChecked = true;
        }

        var currentCheckboxSlug = $(this).attr("name");

        $('.loadfromajaxambassador').each( function() {
            $(this).prop('checked',false);

            if (currentCheckboxSlug != $(this).attr("name")) {
                $('label[for="' + $(this).attr("id") + '"]').removeClass('search-filter__tab--active')
            }
        });

        if (currentCheckboxChecked) {
            $(this).prop('checked',true);
        }
        //Remove last filter when new filter is checked ||END||

        //Change load more btn text ||START||

        var btn_text = $(this).attr('data-btn-text');

        $('#load-more-ambassadors-btn').text(btn_text);

        //Change load more btn text ||END||

        var data = $('.ambassador').parents('form').serialize();

        var is_listing = $(this).parents("form").attr("data-listing");

        if (is_listing == null){
            is_listing = 0;
        }

        $.ajax({
            'url': ajaxurl,
            'type': 'GET',
            'data': data + '&is_listing=' + is_listing + '&action=get_ambassador_search_action',
            success: function (response) {
                var res = JSON.parse(response);
                $('#ambassador-result').empty().append(res);
                AOS.refresh();
            }
        });
    });

    function load_ambassador_new_filter(selectedValue){

        //var is_listing = $(selectedValue).parents("form").attr("data-listing");

        //if (is_listing == null){
        //    is_listing = 0;
        //}

	
	
        const data = `ambassador_type[${selectedValue}]=${selectedValue}`;

	let data2 = ''
	
	if ($(".loadfromajaxambassador_new__order").length) {
	    const selectValueOrder = $(".loadfromajaxambassador_new__order").val();
	    data2 = `&ambassador_order[${selectValueOrder}]=${selectValueOrder}`
	}
	
        $.ajax({
            'url': ajaxurl,
            'type': 'GET',
            'data': data + data2 + '&is_listing=' + true + '&action=get_ambassador_search_action',
            success: function (response) {
                var res = JSON.parse(response);
                $('#ambassador-result').empty().append(res);
                AOS.refresh();
            }
        });
	
	
    }

    $('.loadfromajaxambassador_new').on('change', function() {
        const selectedValue = $(this).val();
	load_ambassador_new_filter(selectedValue);
    });
    $('.loadfromajaxambassador_new__order').on('change', function() {
        const selectedValue = $('.loadfromajaxambassador_new').val();
	load_ambassador_new_filter(selectedValue)
    });
    

    
    // Change ajax pagination href --------------

    $(document).on('click touch', '#ajax-search-pagination a', function(e) {
        e.preventDefault();

        var link = $(this).attr('href');

        var newLink = "";
        if (link.includes("page")) {
            newLink = link.substring(link.indexOf("page"));
        } else if (link.includes("?")) {
            newLink = link.substring(link.indexOf("?"));
        }

        var pageLink = $('#search-page').attr("data-current-link");

        var resultsLink = pageLink + newLink;

        window.location.href = resultsLink;

    });

    $(document).on('click touch', '#ajax-ambassador-pagination a', function(e) {
        e.preventDefault();

        var link = $(this).attr('href');

        var newLink = "";
        if (link.includes("page")) {
            newLink = link.substring(link.indexOf("page"));
        } else if (link.includes("?")) {
            newLink = link.substring(link.indexOf("?"));
        }

        var pageLink = $('#ambassador-result').attr("data-current-link");

        var resultsLink = pageLink + newLink;

        window.location.href = resultsLink;

    });

    $(document).on('click touch', '#ajax-article-pagination a', function(e) {
        e.preventDefault();

        var link = $(this).attr('href');

        var newLink = "";
        if (link.includes("page")) {
            newLink = link.substring(link.indexOf("page"));
        } else if (link.includes("?")) {
            newLink = link.substring(link.indexOf("?"));
        }

        var pageLink = $('#article-result').attr("data-current-link");

        var resultsLink = pageLink + newLink;

        window.location.href = resultsLink;

    });

    $(document).on('click touch', '#ajax-recipe-pagination a', function(e) {
        e.preventDefault();

        var link = $(this).attr('href');

        var newLink = "";
        if (link.includes("page")) {
            newLink = link.substring(link.indexOf("page"));
        } else if (link.includes("?")) {
            newLink = link.substring(link.indexOf("?"));
        }

        var pageLink = $('#recipe-result').attr("data-current-link");

        var resultsLink = pageLink + newLink;

        window.location.href = resultsLink;

    });

    // EVENT LISTING ---------------------------------------------------------------

    $(document).on("click touch", ".listing-card__show", function() {
        $(this).next(".listing-card__more-data").slideToggle();
    });

    $(document).on("click touch", ".listing-card__show__more", function() {
        $(this).next(".listing-card__show__less").css("display", "flex");
        $(this).css("display", "none");
    });

    $(document).on("click touch", ".listing-card__show__less", function() {
        $(this).prev(".listing-card__show__more").css("display", "flex");
        $(this).css("display", "none");
    });


    // CASTLE LISTING ---------------------------------------------------------------
    $('.castle-listing__advanced-filters-btn').on("touch click", function () {
        $(".castle-listing__advanced-filters").slideToggle();
    });

    $('.castle-listing__advanced-filters-close').on("touch click", function () {
        $(".castle-listing__advanced-filters").slideToggle();
    });

    $('.castle-listing__advanced-filters-preview__delete').on("touch click", function() {
       var checkboxTarget = $(this).attr("data-filter-target");
        $(this).parent().remove();

        $('#' + checkboxTarget).prop('checked', false);
        $('.' + checkboxTarget).each( function(){
            $(this).prop('checked', false);

        });

        var filter = $(".castle-listing__appellation-filters").find("input[name='castles[appellation][" + checkboxTarget + "]']");

        $(filter).prop("checked", false);
        var filterName = $(filter).attr('id');
        $("label[for='"+ filterName +"']").removeClass("search-filter__tab--active");
    });

    // Delete all filter preview -> and uncheck all boxes
    $('.castle-listing__advanced-filters-preview-delete-all').on("touchstart click", function() {

        $(this).remove();
        $(".castle-listing__advanced-filters-preview__title").remove();

        $(".castle-listing__advanced-filters-preview__filter").each( function() {
            $(this).remove();
        });

        $('input:checkbox').prop('checked', false);
    });


    //-- Hide/show checkboxes on small screens && Change slide down arrow icon ------

    $(".castle-listing__advanced-filters__label").on("click", function () {
        if ($(window).width() < 576) {
            $(this).find('.castle-listing__advanced-filters__label-icon').toggleClass("fa-sort-down").toggleClass("fa-sort-up");
            var container = $(this).next(".castle-listing__advanced-filters__filter-checkbox-container");
            $(container).slideToggle();

        }
    });

    //PAGINATION WITH AJAX (For Castle Listing) ----------------------------------------------------

    $(document).on('click', '#ajaxCastlePagination a', function (e) {
        e.preventDefault();

        var height = $(".castle-listing-results-container").height();
        $(".castle-listing-results-container").css("minHeight", height);

        $(".castle-listing-results").fadeOut("fast");
        var link = jQuery(this).attr('href');

        if (link.includes("page")) {
            var newLink = link.substring(link.indexOf("page") - 1);
        } else {
            var newLink = link.substring(link.indexOf("?castles") - 1);
        }

        var pageLink = $("#castle-form").attr("data-link");

        newLink = pageLink + newLink;


        $('#castle-listing-results').load(newLink + ' #castle-listing-results', function () {
            $(".castle-listing-results").fadeIn();
            var height = $(".castle-listing-results").height();
            $(".castle-listing-results-container").css("minHeight", height);
        });

    });


    // TIMELINE YEAR  ---------------------------------------------------------------
    $('.story__slider').slick({
        centerMode: true,
        centerPadding: '0',
        initialSlide: 0,
        slidesToShow: 3,
        nextArrow: '<i class="story__next fas fa-long-arrow-right"></i>',
        prevArrow: '<i class="story__prev fas fa-long-arrow-left"></i>',
        draggable: false,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    draggable: true,
                    slidesToShow: 2

                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    //------Fix for last slide jump -----------------------

    $('.story__slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var direction = "left";

        if (Math.abs(nextSlide - currentSlide) == 1) {
            direction = (nextSlide - currentSlide > 0) ? "right" : "left";
        }
        else {
            direction = (nextSlide - currentSlide > 0) ? "left" : "right";
        }

        var theNextSlide = $(".slick-active.slick-center").next(".slick-slide");
        var thePrevSlide = $(".slick-active.slick-center").prev(".slick-slide");

        if (direction === "right" && $(theNextSlide).attr("tabindex") == "-1") {
            $(theNextSlide).addClass("slickcenteryearfix");

            setTimeout(function () {
                $(theNextSlide).removeClass("slickcenteryearfix");
            }, 500);
        }
        if (direction === "left" && $(thePrevSlide).attr("tabindex") == "-1") {
            $(thePrevSlide).addClass("slickcenteryearfix");

            setTimeout(function () {
                $(thePrevSlide).removeClass("slickcenteryearfix");
            }, 500);
        }
    });

    // BLOCK LEXICON ---------------------------------------------------------------

    // Collapse words
    $('.lexicon-letter__letter').click(function () {
        var letterContainer = $(this).parent();
        var letterCollapse = letterContainer.nextAll('.collapse-content:first');
        var letterContent = $(this).attr('data-target');

        $('.lexicon-description').slideUp(200);
        $('.lexicon-description__close').css('display', 'none');

        if ($(letterCollapse).css('display') == 'none') {
            $('.lexicon-letter__letter').removeClass('lexicon-letter__letter--active');
            $(this).addClass('lexicon-letter__letter--active');
            $(letterCollapse).html($(letterContent).html());
            $('.collapse-content').slideUp(200);
            $(letterCollapse).slideDown(200);

        } else if ($(letterCollapse).css('display') == 'block') {
            if ($(this).hasClass('lexicon-letter__letter--active')) {
                $('.lexicon-letter__letter').removeClass('lexicon-letter__letter--active');
                $(letterCollapse).slideUp(200);
            } else {
                $('.lexicon-letter__letter').removeClass('lexicon-letter__letter--active');
                $(this).addClass('lexicon-letter__letter--active');
                $(letterCollapse).html($(letterContent).html());
                $(letterCollapse).slideDown(0);
            }
        }
    });

    $(document).on('click', '.lexicon-words__word', function (e) {
        e.preventDefault();

        var wordTarget = $(this).attr('data-target');
        var descriptionPath = $('.collapse-content [data-id="' + wordTarget + '"]');

        if ($(descriptionPath).css('display') == 'none') {
            $('.lexicon-words__word').removeClass('lexicon-words__word--active');
            $(this).addClass('lexicon-words__word--active');
            $('.lexicon-words').addClass('lexicon-words--border-bottom');
            $('.lexicon-description').slideUp(0);
            $('.lexicon-description__close').css('display', 'block');
            $(descriptionPath).slideDown(0);
            $(descriptionPath).css('height', '');
            $('html,body').animate({scrollTop: descriptionPath.offset().top - 200}, 'fast');

        } else if ($(descriptionPath).css('display') == 'block') {
            if ($(this).hasClass('lexicon-words__word--active')) {
                $('.lexicon-words__word').removeClass('lexicon-words__word--active');
                $(descriptionPath).slideUp(200);
                $('.lexicon-words').removeClass('lexicon-words--border-bottom');
                $('.lexicon-description__close').css('display', 'none');
            } else {
                $('.lexicon-words__word').removeClass('lexicon-words__word--active');
                $(this).addClass('lexicon-words__word--active');
                $('.lexicon-description').slideUp(0);
            }
        }

    });

    $(document).on('click', '.lexicon-description__close', function () {
        $('.lexicon-description__close').css('display', 'none');
        $('.lexicon-words').removeClass('lexicon-words--border-bottom');
        $('.lexicon-description').slideUp(200);
        var wordsContainer = $(this).parent().parent();
        $('html,body').animate({scrollTop: wordsContainer.offset().top - 200}, 'fast');
    });


// BLOCK TIMELINE MILLESIMES  ------------------------------------------------------

    //Disable link on timeline if not active
    $(".timeline-millesime__box__a").on("click", function(event){
        if ($(this).parents('.slick-center').length) {
        } else {
            var index = $(this).parent().data('slick-index');
            $('.timeline-millesime-not-ranking__slider').slick('slickGoTo', index);
            $('.timeline-millesime-ranking__slider').slick('slickGoTo', index);

            return false;
        }
    })

    $('.timeline-millesime__box').on('click', function (e) {
        var index = $(this).data('slick-index');
        $('.timeline-millesime-not-ranking__slider').slick('slickGoTo', index);
    });

    $('.timeline-millesime__box').on('click', function (e) {
        var index = $(this).data('slick-index');
        $('.timeline-millesime-ranking__slider').slick('slickGoTo', index);
    });


    $('.timeline-millesime-not-ranking__slider').slick({
        centerMode: true,
        centerPadding: '60px',
        slidesToShow: 7,
        nextArrow: '<i class="timeline-millesime__next fal fa-long-arrow-right"></i>',
        prevArrow: '<i class="timeline-millesime__prev fal fa-long-arrow-left"></i>',
        draggable: false,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    draggable: true,
                    arrows: true,
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 767,
                settings: {
                    arrows: true,
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 1
                }
            }
        ]
    });

    //------Fix for last slide jump -----------------------

    $('.timeline-millesime-not-ranking__slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var direction = "left";
        if (Math.abs(nextSlide - currentSlide) == 1) {
            direction = (nextSlide - currentSlide > 0) ? "right" : "left";
        }
        else {
            direction = (nextSlide - currentSlide > 0) ? "left" : "right";
        }


        var theNextSlide = $(".slick-active.slick-center").next(".slick-slide");
        if (direction === "right" && $(theNextSlide).attr("tabindex") == "-1") {
            $(theNextSlide).addClass("slick-center-2");

            setTimeout(function () {
                $(theNextSlide).removeClass("slick-center-2");
            }, 500);
        }
    });

    $('.chancellery-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var direction = "left";
        if (Math.abs(nextSlide - currentSlide) == 1) {
            direction = (nextSlide - currentSlide > 0) ? "right" : "left";
        }
        else {
            direction = (nextSlide - currentSlide > 0) ? "left" : "right";
        }


        var theNextSlide = $(".slick-active.slick-center").next(".slick-slide");

        var theNextNextSlide = $(theNextSlide).next(".slick-slide");
        console.log($(theNextNextSlide).attr("data-slick-index"));

        if (direction === "right" && $(theNextSlide).attr("tabindex") == "-1") {
            $(theNextSlide).addClass("slick-center-2");
            $(theNextNextSlide).addClass("slick-center-remove-style");

            setTimeout(function () {
                $(theNextSlide).removeClass("slick-center-2");
                $(theNextNextSlide).removeClass("slick-center-remove-style");

            }, 500);
        }
    });


// BLOCK TIMELINE ClASSEMENT  ------------------------------------------------------

    $('.timeline-millesime-ranking__slider').slick({
        centerMode: true,
        centerPadding: '60px',
        slidesToShow: 5,
        initialSlide: 0,
        infinite: true,
        nextArrow: '<i class="timeline-millesime__next fal fa-long-arrow-right"></i>',
        prevArrow: '<i class="timeline-millesime__prev fal fa-long-arrow-left"></i>',
        draggable: false,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    draggable: true,
                    arrows: true,
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 767,
                settings: {
                    arrows: true,
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 1
                }
            }
        ]
    });

// BLOCK TIMELINE YEAR (vertical)  -------------------------------------------------
    var currentSlide = $(".select-timeline-year option:selected").val();
    var dataId = $('.timeline-year-content').attr('data-id');

    $('.timeline-year-content').on('init', function (event, slick) {
        displaySlides();
    });

    $('.timeline-year-content').slick({
        centerMode: true,
        centerPadding: '50%',
        vertical: true,
        slidesToShow: 1,
        infinite: false,
        initialSlide: 3,
        currentSlide: currentSlide,
        nextArrow: $('.timeline-year__scroll-btn--down'),
        prevArrow: $('.timeline-year__scroll-btn--up'),
        draggable: false,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    draggable: true,
                    centerPadding: '690px'
                }
            },
            {
                breakpoint: 767,
                settings: {
                    centerPadding: '120px',
                    slidesToShow: 1
                }
            },

        ]
    });

    if (typeof dataId !== typeof undefined && dataId !== false) {
        currentId = $('.timeline-year-content').attr('data-id');
        currentSlide = $(".timeline-year-content__row[data-id=" + currentId + "]").attr('data-slick-index');
        $('.timeline-year-content .slick-slide').each(function () {
            $(this).removeClass("slick-current");
        });
        $('.timeline-year-content').slick('slickGoTo', currentSlide);
    };


    $('.select-timeline-year').change(function () {
        currentSlide = $(this).val();
        $('.timeline-year-content .slick-slide').each(function () {
            $(this).removeClass("slick-current");
        });
        $('.timeline-year-content').slick('slickGoTo', currentSlide);

        //scroll to selected date
        var paddingTopList = parseFloat($('.slick-list').css('padding-top').replace(/[^-\d\.]/g, ''));
        var listOffset = $('.slick-list').offset().top;

        $('html,body').animate({
            scrollTop: listOffset + (paddingTopList / 2)
        }, '1000');

    });

    $('.timeline-year-content .slick-slide').on("click", function () {

        $('.timeline-year-content .slick-slide').each(function () {
            $(this).removeClass("slick-current");
        });
        $(this).addClass("slick-current");
    });

    function displaySlides() {
        $('div[aria-hidden = ' + true + ']').css({"opacity": "0"});
        var currentSlide = parseFloat($('.slick-current').attr('data-slick-index'));
        var previousSlide = currentSlide - 1;
        var nextSlide = currentSlide + 1;
        $('div[data-slick-index = ' + previousSlide + ']').css({"opacity": "1"});
        $('div[data-slick-index = ' + currentSlide + ']').css({"opacity": "1"});
        $('div[data-slick-index = ' + nextSlide + ']').css({"opacity": "1"});
    }

    $('.timeline-year-content').on('beforeChange', function () {
        var currentSlide = parseFloat($('.slick-current').attr('data-slick-index'));
        var previousSlide = currentSlide - 1;
        var nextSlide = currentSlide + 1;
        $('div[data-slick-index = ' + nextSlide + ']').next().css({"opacity": "1", "transition-duration": "0.3s"});
        $('div[data-slick-index = ' + previousSlide + ']').prev().css({"opacity": "1", "transition-duration": "0.3s"});
    });

    $('.timeline-year-content').on('afterChange', function () {
        displaySlides();
    });




// TIMELINE CHANCELLERY -----------------------------------------------------------------------
    $('.chancellery-slider').slick({
        centerMode: true,
        slidesToShow: 5,
        initialSlide: 0,
        nextArrow: '<i class="timeline-millesime__next fal fa-long-arrow-right"></i>\n',
        prevArrow: '<i class="timeline-millesime__prev fal fa-long-arrow-left"></i>\n',
        draggable: false,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    draggable: true,
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    $('.chancellery-slider__slide').on('click', function (e) {
        var index = $(this).data('slick-index');
        $('.chancellery-slider').slick('slickGoTo', index);
    });


// CONTACT ------------------------------------------------------------------------------------
    $('input[name="contact[profile]"]').change(function () {
        if ($(this).is('#contact-type-2') && $(this).is(':checked')) {
            $('#profilDetail').removeAttr('disabled');
        } else if ($(this).is('#contact-type-1') && $(this).is(':checked')){
            $('#profilDetail').attr('disabled', 'disabled')
        }
    });

    //check if captcha is validated

    $(".contact-form").on("submit", function(event){

        if(captchaIsValidated) {

        }
        else {
            event.preventDefault();
            $("#error-captcha").show();
        }

    });

    // SET DYNAMICALLY OBJECT FITTED IMAGE PARENT HEIGHT
    function resizeObjectFittedImages() {
        if($(window).width() > 576) {
            $(".object-fit-container").each( function(){

                var referenceChild = $(this).parent().find(".object-fit-container-ref");
                var heightReference = referenceChild.outerHeight();
    -            $(this).height(heightReference);
            });

        }
    }
    resizeObjectFittedImages();
    $(window).on('resize', function(){
        resizeObjectFittedImages();
    });

    /**
     * Newsletter form
     */


    if ( pll_current_language.lang == 'zh') {
        pll_current_language.lang = 'zh-CN';
    }

    $('.newsletter-form__date').datepicker({
        language: pll_current_language.lang
    });

    // SHARER -----------------------------------------------------------------------

    async function copyPageUrl() {
        const txt = this.dataset.sharer
        try {
            await navigator.clipboard.writeText(location.href);
            const feedback = '<strong>' + txt + '</strong>';
            $this = $(this)
            $this.append(feedback);
            setTimeout(function() {
                $this.find('strong').fadeOut(300)
            }, 2000)
        } catch (err) {
            console.error('Failed to copy: ', err);
        }
    }
    $('[data-sharer]').on('click', copyPageUrl);


    // CASTLE GALLERY SLIDER ------------------------------------------------------------
    
    $castleMobileGallerySlider = $('.castle-mobile-gallery__slider');
    $castleMobileGallerySliderNumbers = $('.castle-mobile-gallery__numbers');
    $castleMobileGallerySlider.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
        var i = (currentSlide ? currentSlide : 0) + 1;
        $castleMobileGallerySliderNumbers.text(i + '/' + slick.slideCount);
    });
    $castleMobileGallerySlider.slick();

    // CASTLE WINEMAKERS SLIDER ---------------------------------------------------------
    
    $castleWinemakersCrossContentSlider = $('.castle-winemakers-cross-content__slider');
    if ($castleWinemakersCrossContentSlider.length) {
        $castleWinemakersCrossContentProgressBar = $('.castle-winemakers-cross-content__progressbar');
        $castleWinemakersCrossContentSlider.on('init reInit beforeChange', function(event, slick, currentSlide, nextSlide){
            var i = (nextSlide ? nextSlide : 0) + 1;
            var percentage = i / slick.slideCount
            $castleWinemakersCrossContentProgressBar.children().css('scale', percentage + ' 1')
        });
        $castleWinemakersCrossContentSlider.slick({
            slidesToShow: 2,
            infinite: false,
            arrows : false,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1.5
                    }
                },
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 1.2
                    }
                }
            ]
        });
    }

    // CASTLE EVENTS SLIDER ------------------------------------------------------------

    $castleEvents = $('.castle-events');
    if ($castleEvents.length) {
        $castleEventsList = $castleEvents.find('.castle-events__list');
        $castleEventsListItems = $castleEventsList.children();
        console.log($castleEventsListItems)
        if ($castleEventsListItems.length > 2) {
            $castleEventsProgressbar = $castleEvents.find('.castle-events__progressbar')
            $castleEventsList.on('init reInit beforeChange', function(event, slick, currentSlide, nextSlide){
                var slidesToShow = slick.slickGetOption('slidesToShow');
                var i = (nextSlide ? nextSlide : 0) + slidesToShow;
                var percentage = (i / slick.slideCount)
                $castleEventsProgressbar.children().css('scale', percentage + ' 1')
            });
            $castleEventsList.on('init', function(event, slick, currentSlide, nextSlide){
                var slidesNumber = slick.slideCount;
                if (slidesNumber > 2) {
                    $castleEvents.addClass('is-slider')
                }
            });
            $castleEventsList.slick({
                slidesToShow: 2,
                infinite: false,
                arrows : true,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });
        }
    }

});

$(window).on('load', function () {
    AOS.refresh();
});

var captchaIsValidated = false;

window.recaptchaCallback = recaptchaCallback;
function recaptchaCallback() {
    captchaIsValidated = true;
}


// Ajouts Avril 2024

jQuery(document).ready(function ($) {
    var $blockTimeline = $('.block-timeline');

    function SlideToMatchingYear(year, matchingSlider) {
        var matchingSlide = matchingSlider.find('[data-year=' + year + ']');
        var matchingSlideIndex = matchingSlide.index();
        matchingSlider.slick('slickGoTo', matchingSlideIndex);
    }

    $blockTimeline.each(function() {
        var $this = $(this);
        var $yearsSlider = $this.find('.block-timeline__years-slider');
        var $yearsSlides = $this.find('.block-timeline__years-slide');
        var $coreSlider = $this.find('.block-timeline__core-slider');
    
        $coreSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            var nextSlide = slick.$slides.get(nextSlide)
            var year = nextSlide.dataset.year
            SlideToMatchingYear(year, $yearsSlider)
        })
        
        $coreSlider.slick({
            slidesToShow: 1,
            infinite: false,
            prevArrow: $this.find('.block-timeline__core-slider-prev-btn'),
            nextArrow: $this.find('.block-timeline__core-slider-next-btn')
        });

        $yearsSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            var nextSlide = slick.$slides.get(nextSlide)
            var year = nextSlide.dataset.year
            SlideToMatchingYear(year, $coreSlider)
        })

        $yearsSlider.slick({
            slidesToShow: 1,
            infinite: false,
            variableWidth: true,
            focusOnSelect: true,
            prevArrow: '<button class="block-timeline__years-slider-prev-btn"></button>',
            nextArrow: '<button class="block-timeline__years-slider-next-btn"></button>',
        });

        // $yearsSlides.each(function() {
        //     var $this = $(this);
        //     $this.on('click', function() {
        //         var year = $this.data('year')
        //         var currentSlideIndex = $this.index();
        //         $yearsSlider.slick('slickGoTo', currentSlideIndex);
        //         SlideToMatchingYear(year, $coreSlider)
        //         // $this.addClass('slick-current').siblings().removeClass('slick-current')
        //     })
        // })
    })

    $mobileMenuMainMenu = $('.mobile-menu__main-menu');
    $mobileMenuSubmenu = $('.mobile-menu__submenu');
    $mobileMenuSubmenuLabel = $('.mobile-menu__submenu-label');

    $mobileMenuMainMenu.find('a').each(function() {
        var $this = $(this);
        var $submenu = $this.next('.mobile-menu__submenu');
        if ($submenu.length) {
            $this.on('click', function(e) {
                e.preventDefault();
                $submenu.toggleClass('is-visible');
            })
        }
    })

    $mobileMenuSubmenuLabel.each(function() {
        var $this = $(this);
        var $parent = $this.parent();
        $this.on('click', function() {
            $parent.removeClass('is-visible');
        })
    })

    $mobileMenuSubmenu.find('a').each(function() {
        var $this = $(this);
        var $submenu = $this.next('ul');
        if ($submenu.length) {
            $this.on('click', function(e) {
                e.preventDefault();
                $submenu.toggleClass('is-visible');
            })
        }
    })
})
